import React from 'react'
import { ResponsiveTableRow, Skeleton } from '@fs/zion-ui'

const SkeletonWrapper = ({ children }) => <div style={{ maxHeight: 36 }}>{children}</div>

export default function UploadRowSkeleton(props) {
  return (
    <ResponsiveTableRow
      column1={
        <SkeletonWrapper>
          <Skeleton.Paragraph maxWidth={80} size="sm" />
        </SkeletonWrapper>
      }
      column2={
        <SkeletonWrapper>
          <Skeleton.Paragraph maxWidth={100} size="sm" />
        </SkeletonWrapper>
      }
      column3={
        <SkeletonWrapper>
          <Skeleton.Paragraph maxWidth={60} size="sm" />
        </SkeletonWrapper>
      }
      column4={
        <SkeletonWrapper>
          <Skeleton.Paragraph maxWidth={60} size="sm" />
        </SkeletonWrapper>
      }
      column5={
        <SkeletonWrapper>
          <Skeleton.Paragraph maxWidth={80} size="sm" />
        </SkeletonWrapper>
      }
      column6={
        <SkeletonWrapper>
          <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
            <Skeleton.Button data-testid="fake-testid" />
          </div>
        </SkeletonWrapper>
      }
      {...props}
    />
  )
}
